// extracted by mini-css-extract-plugin
export default {"textConfig":"Sunset_textConfig__g8rjr","header":"Sunset_header__3gEB4","main":"Sunset_main__3isGj","footer":"Sunset_footer__X53nO","separator":"Sunset_separator__8QNMd"};